// extracted by mini-css-extract-plugin
module.exports = {"row":"row-component_row__xpSw4","row__rank":"row-component_row__rank__2Glkz"};